import React, { useState, useEffect, useContext, useRef } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { Link } from "react-router-dom";
import Search from "../Search";
import "./Header.css";
import { CiLight, CiDark } from "react-icons/ci";

const Header = () => {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [years, setYears] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    fetch("https://phimapi.com/the-loai/")
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch((err) => console.error("Error fetching categories:", err));

    fetch("https://phimapi.com/quoc-gia/")
      .then((res) => res.json())
      .then((data) => setCountries(data))
      .catch((err) => console.error("Error fetching countries:", err));

    const mockYears = Array.from({ length: 26 }, (_, index) => 2000 + index).reverse();
    setYears(mockYears);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterActive(false);
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDropdownClick = (dropdown) => {
    setActiveDropdown((prevDropdown) => (prevDropdown === dropdown ? null : dropdown));
    if (activeDropdown === dropdown) setIsFilterActive(false);
  };

  const handleFilterClick = () => {
    setIsFilterActive((prev) => !prev);
    setActiveDropdown(null);
  };

  const handleDropdownItemClick = () => {
    setIsFilterActive(false);
    setActiveDropdown(null);
  };
  
  return (
    <header className="header">
      <div className="logo-container">
        <Link to="/trang-chu">
          <img src="/logo-movie.svg" alt="Movie Logo" className="logo" />
        </Link>
        <h1 className="site-title">XEM PHIM CÙNG ZĂN HẢO</h1>
      </div>
      <div className="logo-container-2" ref={dropdownRef}>
        <button className="dropdown-btn" onClick={handleFilterClick}>
          <img src="/menu.svg" alt="Menu" className="menu-icon" />
        </button>
        <nav className={`dropdown-nav ${isFilterActive ? "active" : ""}`}>
          <div className="dropdown">
            <button className="dropdown-btn-l1" onClick={() => handleDropdownClick("categories")}>
              Thể Loại
            </button>
            {activeDropdown === "categories" && (
              <div className="dropdown-content">
                {categories
                  .filter(category => category.name !== "Phim 18+") 
                  .map((category) => (
                    <Link to={`/the-loai/${category.slug}`} key={category.id} onClick={handleDropdownItemClick}>
                      {category.name}
                    </Link>
                  ))}
              </div>
            )}
          </div>
          <div className="dropdown">
            <button className="dropdown-btn-l1" onClick={() => handleDropdownClick("countries")}>
              Quốc Gia
            </button>
            {activeDropdown === "countries" && (
              <div className="dropdown-content">
                {countries.map((country) => (
                  <Link to={`/quoc-gia/${country.slug}`} key={country.id} onClick={handleDropdownItemClick}>
                    {country.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
          <div className="dropdown">
            <button className="dropdown-btn-l1" onClick={() => handleDropdownClick("years")}>
              Năm
            </button>
            {activeDropdown === "years" && (
              <div className="dropdown-content">
                {years.map((year) => (
                  <Link to={`/nam/${year}`} key={year} onClick={handleDropdownItemClick}>
                    {year}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </nav>
        <Search />
        <div className="theme-switcher" onClick={toggleTheme} style={{ cursor: "pointer", fontSize: "1.5rem" }}>
          {isDarkMode ? <CiDark color="#FFD700" /> : <CiLight color="#FFA500" />}
        </div>
      </div>
    </header>
  );
};

export default Header;
